const GET_TERRIT_COMPAT_INIT = 'OVID/GET_TERRIT_COMPAT_INIT'
const GET_TERRIT_COMPAT_SUCCESS = 'OVID/GET_TERRIT_COMPAT_SUCCESS'
const GET_TERRIT_COMPAT_ERROR = 'OVID/GET_TERRIT_COMPAT_ERROR'

export const constants = {
  GET_TERRIT_COMPAT_INIT,
  GET_TERRIT_COMPAT_SUCCESS,
  GET_TERRIT_COMPAT_ERROR,
}
